import DirectionalExternalArrow from "@/components/ui/DirectionalExternalArrow";
import { type Locale, isBlogPath } from "@/lib/i18n/config";
import { localizeBlogHref, localizeHref } from "@/lib/i18n/routing";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

export const navigationMenuTriggerStyle = cva(
  "group/navigation-menu-trigger inline-flex h-9 w-max cursor-pointer items-center justify-center rounded-lg px-2.5 py-1.5 text-sm font-medium transition-all outline-none hover:bg-foreground/[0.04] hover:text-foreground focus:bg-foreground/[0.04] focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 data-popup-open:bg-foreground/[0.04] data-popup-open:hover:bg-foreground/[0.06] data-open:bg-foreground/[0.04] data-open:hover:bg-foreground/[0.06] data-open:focus:bg-foreground/[0.04]",
);

export function NavChevronDown({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={cn("size-3", className)}
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}

export function resolveHref(href: string, locale: Locale, external?: boolean) {
  if (external) {
    return href;
  }

  const path = href.startsWith("/") ? href : `/${href}`;

  if (isBlogPath(path)) {
    return localizeBlogHref(href, locale);
  }

  return localizeHref(href, locale);
}

export function NavExternalLabel({
  label,
  external,
  className,
}: {
  label: string;
  external?: boolean;
  className?: string;
}) {
  if (!external) {
    return <span className={className}>{label}</span>;
  }

  return (
    <span className={cn("inline-flex items-center gap-0.5", className)}>
      {label}
      <DirectionalExternalArrow className="size-3.5" />
    </span>
  );
}
